<template>
  <div>
    <vs-card class="cardx">
      <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;">
        <feather-icon @click="$router.go(-1)" icon="ArrowLeftIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
        <h3>
          {{title}}
        </h3>
      </div>
      <div>

        <vs-row >
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.name"
              type="text"
              name="name"
              v-validate="'required'"
              :danger="errors.has('name')"
              :danger-text="errors.has('name')? errors.first('name'):null"
              val-icon-danger="close"
              label="Name"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.description"
              name="description"
              type="text"
              v-validate="'required|min:10'"
              :danger="errors.has('description')"
              :danger-text="errors.has('description')? errors.first('description'):null"
              val-icon-danger="close"
              label="Description"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>

        </vs-row>

        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-button color="primary" @click="submit" type="filled">Save</vs-button> 
          </vs-col>
        </vs-row>
      </div>
      <div>
          <vs-table
            stripe
            :sst="true"
            :data="partners.partners">
            <template slot="thead">
              <vs-th sort-key="name">
                Name
              </vs-th>
              <vs-th sort-key="description">
                Description
              </vs-th>
              <vs-th>
                Action
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="partner.id" v-for="partner in data">
                <vs-td>
                  {{partner.name}}
                </vs-td>
                <vs-td>
                  {{partner.description}}
                </vs-td>
                <vs-td>
                  <feather-icon icon="EditIcon" @click="edit(partner.id)" class="cursor-pointer navbar-fuzzy-search mr-4" />
                  <feather-icon icon="SettingsIcon" @click="setting(partner.id)" class="cursor-pointer navbar-fuzzy-search mr-4" />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="mt-3 mb-3">
            <pagination :last-page="partners.pagination.pages" v-model="filters.page" />
          </div>
      </div>
    </vs-card>

  </div>

</template>
<style itemscope>
  .img-inputer {
    width: 150px;
    height: 150px;
  }
</style>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import ImgInputer from 'vue-img-inputer';


  export default {
    name :'EditPartner',
    components: {
      ImgInputer,
    },
    data(){
      return {
        filters: {},
        title : null,
        form:{
          name: null,
          description: null
        },
        onSubmit : false,
        image : null,

        data_timeline : []
      }
    },
    computed : {
      ...mapState('partners',['partners']),
      ...mapGetters('users',['userCan'])
    },
    watch :{
      '$route.params.id': function (id) {
        this.initData();
      }
    },
    created() {
      this.initData();
    },
    methods: {
      ...mapActions('partners',['getPartner','storePartner','updatePartner']),
      initData(){
        if(this.$route.params.id){
          this.title = 'Edit partner';
          this.getPartner({id: this.$route.params.id})
            .then(data=>{
              this.form = data;
            })
            .catch(error=>{
              if(error){
                if(error.status === 404){
                  this.$router.push({name: 'page-error-404'});
                }
              }
            })
        }else{
          this.title = 'New partner';
          this.form = {
            name: null,
            description: null
          };
        }
      },
      async submit(){
        let result = await this.$validator.validateAll();
        if (!result || this.onSubmit) {
          return;
        }

        if(this.$route.params.id){
          if(!this.userCan('partners.update')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }
          this.$vs.loading({
            type:'point',
          });
          this.onSubmit = true;

          let form = _.cloneDeep(this.form);

          this.updatePartner(form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Partner successfully updated',this.redirectToPartners);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 400){
                  this.setErrors(error.data.errors);
                }
              }
            })
        }else{
          if(!this.userCan('partners.create')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }
          this.$vs.loading({
            type:'point',
          });
          this.onSubmit = true;
          this.storePartner(this.form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Partner successfully created',this.redirectToPartners);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 400){
                  this.setErrors(error.data.errors);
                }
              }
            })
        }
      },
      msgDialog(color, title, text, action){
        this.$vs.dialog({
          color: color,
          title: title,
          text: text,
          accept:action
        })
      },
      redirectToPartners(){
        this.$router.push({name: 'partners.list'});
      },
      edit(id){
        this.$router.push({name: 'partners.account', params:{id}})
      },
      setting(id){
        console.log('setting', id)
      },
      setErrors(errors){
        for(let key in errors){
          if(Array.isArray(errors[key])){
            this.errors.add({
              field: key,
              msg: errors[key][0]
            });
          }
        }
      },

    },

  }
</script>
